import {
    optionTitle_messageFormat,
    optionSearch_messageFormat,
} from './MessageFormatOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let MessageFormatOption: LazyOption = createLazyOption(
    {
        key: 'messageFormat',
        titleStringKey: optionTitle_messageFormat,
        searchTermsStringKey: optionSearch_messageFormat,
        allowedOptionKeys: ['MessageFormat'],
    },
    lazyFullModule,
    m => m.default
);
export default MessageFormatOption;
